import { createComponent } from '../lib';
import { VmDefaultControls, VmCaptionControl, VmControl, VmIcon, VmTooltip, VmControlGroup, VmControlSpacer, VmControls, VmCurrentTime, VmTime, VmEndTime, VmFullscreenControl, VmLiveIndicator, VmMuteControl, VmPipControl, VmPlaybackControl, VmScrim, VmScrubberControl, VmSlider, VmSettingsControl, VmTimeProgress, VmVolumeControl } from '@vime/core';
import { define } from '../lib';
define('vm-default-controls', VmDefaultControls);
define('vm-caption-control', VmCaptionControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
define('vm-control-group', VmControlGroup);
define('vm-control-spacer', VmControlSpacer);
define('vm-controls', VmControls);
define('vm-current-time', VmCurrentTime);
define('vm-time', VmTime);
define('vm-end-time', VmEndTime);
define('vm-fullscreen-control', VmFullscreenControl);
define('vm-live-indicator', VmLiveIndicator);
define('vm-mute-control', VmMuteControl);
define('vm-pip-control', VmPipControl);
define('vm-playback-control', VmPlaybackControl);
define('vm-scrim', VmScrim);
define('vm-scrubber-control', VmScrubberControl);
define('vm-slider', VmSlider);
define('vm-settings-control', VmSettingsControl);
define('vm-time-progress', VmTimeProgress);
define('vm-volume-control', VmVolumeControl);
;
export default createComponent('vm-default-controls', new Set(['activeDuration', 'waitForPlaybackStart', 'hideWhenPaused', 'hideOnMouseLeave', 'theme', 'isMobile', 'isLive', 'isAudioView', 'isVideoView']));
